var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShown(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.904 9.282A8.878 8.878 0 0010.002 4a8.88 8.88 0 00-7.906 5.282 1.022 1.022 0 000 .869 8.878 8.878 0 007.906 5.28 8.878 8.878 0 007.902-5.28 1.022 1.022 0 000-.869zm-7.902 4.72a4.154 4.154 0 01-4-4.286 4.153 4.153 0 014-4.287 4.153 4.153 0 014.001 4.287 4.152 4.152 0 01-3.998 4.287h-.003zm0-7.144a2.483 2.483 0 00-.703.114c.17.248.26.541.26.842a1.38 1.38 0 01-1.332 1.424c-.286 0-.564-.097-.788-.275a3.042 3.042 0 00-.092.747 2.763 2.763 0 002.662 2.851 2.763 2.763 0 002.662-2.85 2.763 2.763 0 00-2.662-2.852l-.007-.001z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShown);
export default ForwardRef;